import { Box, CircularProgress, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { StoreState } from "../store/store";
import { ImageService } from "../services/image.service";
import { Images } from "../models/assets-files";

const LoadingPage = ({ covrage = "full", outsideLoading = false }) => {
  const theme = useTheme();
  const isLoading = useSelector((state: StoreState) => state.system.isLoading);

  return (
    <>
      {isLoading || outsideLoading ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            overflow: "hidden",
            zIndex: 10000000,
            background: "white",
          }}
        >
          <Box
            sx={{
              width: "100vw",
              height: "100vh",
              position: "absolute",
              opacity: covrage === "full" ? 1 : 0.5,
            }}
          />
          <Box
            sx={{
              width: "100vw",
              height: "100vh",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ m: 1, position: "relative" }}>
              <Box
                sx={{
                  borderRadius: "50%",
                  width: "150px",
                  height: "150px",
                  backgroundColor: "#01346B",
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "50%",
                    transform: "translate(50%,-50%)",
                    width: "60%",
                  }}
                  src={ImageService.getLocalImgPath(
                    Images.Folders.GENERAL,
                    Images.General.LOGO_WITH_TEXT,
                    "svg"
                  )}
                  alt="Oj platform logo"
                />
              </Box>
              {(isLoading || outsideLoading) && (
                <CircularProgress
                  size={165}
                  sx={{
                    color: theme.palette.primary.main,
                    position: "absolute",
                    top: -6,
                    left: -6,
                    zIndex: 1,
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      ) : null}
    </>
  );
};

export default LoadingPage;
